import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TInput } from './models';

export const Input: FC<TInput> = ({
    Caption,
    Hint,
    IconError,
    IconSuccess,
    PureInput,
    addHiddenInput,
    caption,
    className = '',
    dataTestId = 'input',
    disabled,
    error,
    forwardedRef,
    hideStatusIcon,
    id,
    infoBlock,
    infoText,
    name = '',
    onCancel,
    paddingleft = '',
    placeholder,
    styles,
    success,
    value = '',
    ...rest
}) => (
    <div className={styles.inputWrapper}>
        <label className={styles.label} htmlFor={id}>
            <PureInput
                className={className}
                dataTestId={dataTestId}
                disabled={disabled}
                error={error}
                forwardedRef={forwardedRef}
                hasFloatingLabel={Boolean(placeholder)}
                id={id}
                name={name}
                paddingleft={paddingleft}
                value={value}
                {...rest}
            />

            {addHiddenInput && disabled && (
                <input name={name} readOnly type="hidden" value={value} />
            )}

            <span
                className={cn(styles.placeholder, {
                    [styles.emptyValue]: value === '',
                })}
                style={{ left: paddingleft }}
            >
                {placeholder}
            </span>
        </label>

        <div className={styles.status}>
            {infoBlock && infoText && <Hint>{infoText}</Hint>}
            {!hideStatusIcon && success && <IconSuccess data-test-id={`success-icon-${name}`} />}
            {!hideStatusIcon && error && (
                <button
                    className={styles.cancel}
                    data-test-id="cancel-button"
                    onClick={onCancel}
                    type="button"
                >
                    <IconError data-test-id={`error-icon-${name}`} />
                </button>
            )}
        </div>

        {caption && (
            <Caption
                className={cn(styles.external, styles.caption, {
                    [styles.captionError]: error && !infoBlock,
                })}
                dataTestId={error && !infoBlock ? `captionError-${name}` : `caption-${name}`}
                size="s"
                theme="white"
            >
                {caption}
            </Caption>
        )}
    </div>
);
